import { ReactNode } from 'react';

export type PresentationRole = 'BASIC' | 'PRO' | 'ACHARYA' | 'MANAGEMENT';

export interface RoleConfig {
  id: PresentationRole;
  labelEn: string;
  labelHi: string;
  subtitleEn: string;
  subtitleHi: string;
  descriptionEn: string;
  descriptionHi: string;
  badgeClass: string;
  iconName: string;
}

export const PRESENTATION_ROLES: Record<PresentationRole, RoleConfig> = {
  BASIC: {
    id: 'BASIC',
    labelEn: 'Basic',
    labelHi: 'सरल (बेसिक)',
    subtitleEn: 'Clarity & Direct Answers',
    subtitleHi: 'स्पष्ट एवं प्रत्यक्ष फलादेश',
    descriptionEn: 'Answer-first presentation with plain language verdict, timing, and simple remedies for general clients.',
    descriptionHi: 'प्रत्यक्ष उत्तर, मुख्य समय काल व सरल व्यावहारिक उपायों पर केंद्रित प्रस्तुति।',
    badgeClass: 'bg-emerald-500/15 text-emerald-800 dark:text-emerald-300 border-emerald-500/30',
    iconName: 'Sparkles'
  },
  PRO: {
    id: 'PRO',
    labelEn: 'Pro',
    labelHi: 'विशारद (प्रो)',
    subtitleEn: 'Forensic Astrological Depth',
    subtitleHi: 'गहन शास्त्रीय व गणितीय कार्यक्षेत्र',
    descriptionEn: 'Full astrological workstation with synchronized 3-chart rail, 3-column evidence, and deep calculations.',
    descriptionHi: 'सम्पूर्ण वर्ग चक्र, सर्वाष्टकवर्ग, षड्बल, भाव-ग्रह विश्लेषण व दशा-गोचर संमिलन।',
    badgeClass: 'bg-astro-primary/15 text-astro-primary border-astro-primary/30',
    iconName: 'Compass'
  },
  ACHARYA: {
    id: 'ACHARYA',
    labelEn: 'Acharya',
    labelHi: 'आचार्य (परामर्श)',
    subtitleEn: 'Consultation & Case Notes',
    subtitleHi: 'परामर्श व प्रकरण अभिलेख',
    descriptionEn: 'Client consultation workspace with dual-panel layout, session timer, live notes, and AI Acharya counsel.',
    descriptionHi: 'सक्रिय परामर्श सत्र, परामर्श संदर्भ, लाइव प्रकरण नोट्स, समय-सीमा व आचार्य चिंतन।',
    badgeClass: 'bg-astro-accent/15 text-astro-accent dark:text-[#B7A17A] border-astro-accent/30',
    iconName: 'Award'
  },
  MANAGEMENT: {
    id: 'MANAGEMENT',
    labelEn: 'Management',
    labelHi: 'प्रबंधन',
    subtitleEn: 'Practice Control & Analytics',
    subtitleHi: 'परामर्शदाता अभ्यास प्रबंधन',
    descriptionEn: 'Extensible management tier for client records, astrologer workflow, and clinic operations (Phase 3).',
    descriptionHi: 'क्लाइंट रिकॉर्ड, परामर्शदाता वर्कफ़्लो व संचालन प्रबंधन (चरण ३)।',
    badgeClass: 'bg-purple-500/15 text-purple-900 dark:text-purple-200 border-purple-500/30',
    iconName: 'Shield'
  }
};
